import { useCallback, useMemo } from 'react'
import { GetTagsQueryVariables, useGetTagsQuery } from './graphql/getTags.types'
import { Tag } from 'shared/__gql-types'

type TFilterVars = GetTagsQueryVariables['filter']

export const useTags = (filter?: TFilterVars) => {
  const { data, loading, error } = useGetTagsQuery({
    variables: {
      filter
    }
  })

  const tagsByName = useMemo((): Record<string, Tag> => (data?.tags ?? []).reduce((acc, tag) => ({
    ...acc,
    [tag.label]: tag
  }), {}), [data?.tags])

  const getTagByName = useCallback((name: string) => tagsByName?.[name] ?? undefined, [tagsByName])
  const tags = useMemo(() => data?.tags?.map(({ __typename, ...rest }) => rest) ?? [], [data?.tags])

  return {
    getTagByName,
    tags,
    error,
    loading
  }
}
